import React, { useState } from 'react'
import classNames from 'classnames'
import css from './HowItWork.module.css'
import IconCard from '../SavedCardDetails/IconCard/IconCard'
import { FormattedMessage, useIntl } from 'react-intl'

const HowItWork = () => {
    const [activeTab, setActiveTab] = useState('learners')
    const intl = useIntl()

    return (
        <div className={css.howitworkWrapper}>
            <div className={css.howItWork}>
                <div className={css.howitworkHeader}>
                    <div className={css.headerLeft}>
                        <div className={css.titleWrapper}>
                            <span className={css.howIt}>Comment ça</span>
                            <span className={css.work}>Travail</span>
                        </div>
                        <h2 className={css.subtitle}>Comment commencer avec Formabel</h2>
                    </div>

                    <div className={css.headerRight}>
                        <p className={css.description}>Étapes simples pour commencer à apprendre ou à gagner avec Formabel</p>
                        <div className={css.tabButtons}>
                            <button
                                className={classNames(css.tabBtn, activeTab === 'learners' ? css.active : '')}
                                onClick={() => setActiveTab('learners')}
                            >
                                Pour les Apprenants
                            </button>
                            <button
                                className={classNames(css.tabBtn, activeTab === 'trainers' ? css.active : '')}
                                onClick={() => setActiveTab('trainers')}
                            >
                                Pour les Formateurs
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            {/* steps card section */}

            {
                activeTab === 'learners' ? (<div className={css.stepsCardWrapper}>
                    {
                        learnerCard(intl).map((card) => (
                            <div className={css.stepCard}>
                                <div>
                                    <span className={css.number}>
                                        <IconCard brand={card.icon} />
                                    </span>
                                    {/* <span className={css.number}>{card.number}</span> */}
                                    <h3 className={css.stepTitle}>{card.title}</h3>
                                </div>

                                <p className={css.info} dangerouslySetInnerHTML={{ __html: card.info }}></p>
                            </div>
                        ))
                    }
                </div>) :

                    <div className={css.stepsCardWrapper}>
                        {trainerCard(intl).map((card) => (
                            <div className={css.stepCard}>
                                <div>
                                    <span className={css.number}>
                                        <IconCard brand={card.icon} />
                                    </span>
                                    {/* <span className={css.number}>{card.number}</span> */}
                                    <h3 className={css.stepTitle}>{card.title}</h3>
                                </div>
                                <p className={css.info} dangerouslySetInnerHTML={{ __html: card.info }}></p>
                            </div>
                        ))}
                    </div>
            }


        </div>
    )
}

export default HowItWork

const learnerCard = (intl) => [
    {
        icon: 'teachingOnBoard',
        title: intl.formatMessage({ id: "HowItWork.learnerCard.step1.title" }),
        info: intl.formatMessage({ id: "HowItWork.learnerCard.step1.info" })
    },
    {
        icon: 'chooseFingerPoint',
        title: intl.formatMessage({ id: "HowItWork.learnerCard.step2.title" }),
        info: intl.formatMessage({ id: "HowItWork.learnerCard.step2.info" })
    },
    {
        icon: 'tvRecordingCamera',
        title: intl.formatMessage({ id: "HowItWork.learnerCard.step3.title" }),
        info: intl.formatMessage({ id: "HowItWork.learnerCard.step3.info" })
    },
    {
        icon: 'ideaBulb',
        title: intl.formatMessage({ id: "HowItWork.learnerCard.step4.title" }),
        info: intl.formatMessage({ id: "HowItWork.learnerCard.step4.info" })
    }
]

const trainerCard = (intl) => [
    {
        icon: 'createUserPlus',
        title: intl.formatMessage({ id: "HowItWork.trainerCard.step1.title" }),
        info: intl.formatMessage({ id: "HowItWork.trainerCard.step1.info" })
    },
    {
        icon: 'flyingPaperPlan',
        title: intl.formatMessage({ id: "HowItWork.trainerCard.step2.title" }),
        info: intl.formatMessage({ id: "HowItWork.trainerCard.step2.info" })
    },
    {
        icon: 'mail',
        title: intl.formatMessage({ id: "HowItWork.trainerCard.step3.title" }),
        info: intl.formatMessage({ id: "HowItWork.trainerCard.step3.info" })
    },
    {
        icon: 'circularCheck',
        title: intl.formatMessage({ id: "HowItWork.trainerCard.step4.title" }),
        info: intl.formatMessage({ id: "HowItWork.trainerCard.step4.info" })
    }
]